import Vue from 'vue'

Vue.directive('translate', {
  bind: function (el, binding, vnode) {
    const interpolation = vnode.data.attrs?.interpolate
    el.innerHTML = vnode.context.$t(binding.value, { ...interpolation })
  }
})
